export default __webpack_public_path__ + "static/media/vip.ac228367.svg";